// This middleware check if an user has village invitation
export default function ({ $auth, redirect }) {
  if ($auth.user) {
    const invitation = $auth.user.invitation

    if (invitation)
      return redirect(`/subscription/invitation/${invitation.acceptance_token}`)
  }
}
